import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Offline } from '@seims/shared';

import { initKeycloak } from "./security/AppSecurity";

const root = ReactDOM.createRoot(document.getElementById("root"));
let failedStart = false;
let message;

const startApp = () => {
  initKeycloak(renderApp).then((instance) => {
    failedStart = instance.failedToStart;
    if (failedStart) {
      message = "One of the application services failed to start. Please contact administrator";
      return renderApp(true);
    } else renderApp(false);
  });
};

const renderApp = () => {
  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <Offline />
      <App failedStart={failedStart} message={message} />
    </BrowserRouter>

    // </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

startApp();
